<script setup>
import { RouterView } from 'vue-router';

import { Spinner, Navbar, Sidebar } from '@/components/template';
import Alert from './components/Notifications/NotificationsList.ce.vue';
import { useAuthStore, useLayoutStore } from '@/stores';
const authStore = useAuthStore();
const layoutStore = useLayoutStore();
</script>

<template>
  <div class="app-root">
    <Spinner />
    <template v-if="authStore.user">
      <Sidebar :class="{ open: layoutStore.sidebarOpen }"/>
      <div :class="['content', { open: layoutStore.sidebarOpen }]">
        <Navbar />
        <Alert />
        <RouterView />
      </div>
    </template>
    <div v-else class="auth-layout-wrapper">
      <div class="auth-alert-container">
        <Alert />
      </div>
      <RouterView />
    </div>
  </div>
</template>

<style>
@import 'https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css';
@import "bootstrap/dist/css/bootstrap.min.css";
@import './assets/css/style.css';
@import 'https://use.fontawesome.com/releases/v5.2.0/css/all.css';
@import './assets/css/custom.css';

.auth-layout-wrapper {
  min-height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.auth-alert-container {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  width: 90%;
  max-width: 420px;
}
</style>
